<template>
  <div class="cardTemplate">
    <div class="card mb-4 shadow-sm" id="card-product">
      <router-link
        tag="div"
        :key="item.code_product"
        :to="{ name: 'detalle-productos', params: { id: item.code_product } }"
        class="card-image-product card-template-image"
      >
        <a href="" class="card-template-image-container">
          <img
            class="armaq-top mt-2"
            v-bind:src="imgPreUrl + item.photo_product + '.jpg'"
            alt="Producto"
          />

          <!-- 
         <img
          class="armaq-top mt-2"
          v-bind:src='imgPreUrl+ item.photo_product +"x640.jpg"'
          alt="Producto">
         -->
        </a>
      </router-link>

      <template v-if="item.old_price_product > item.price_product">
        <div class="product-label">
          <span class="new-discount">
            -{{
              Math.round(
                (item.old_price_product - item.price_product) /
                  (item.old_price_product / 100),
              )
            }}%
          </span>
        </div>
      </template>

      <div class="card-body">
        <div class="row">
          <div class="col-sm-12">
            <h6 class="card-text-name">{{ item.name_product_es }}</h6>
          </div>

          <div class="botones-compra">
            <template v-if="item.rank_star_product != 0.0">
              <div class="col-sm-12">
                <div class="stars-outer">
                  <div
                    class="stars-inner"
                    v-bind:style="{
                      width:
                        obtener_promedio_rating(item.rank_star_product) + '%',
                    }"
                  ></div>
                </div>
              </div>
            </template>
            <div class="col-sm-12">
              <template v-if="item.old_price_product > item.price_product">
                <p class="card-text-old-price">
                  Antes:
                  <strike>{{ item.old_price_product | currency }}</strike>
                </p>
              </template>
              <p class="card-text-price">{{ item.price_product | currency }}</p>
            </div>

            <div class="col-sm-12">
              <!--
          <template v-if="item.allowed_sale">
          <div class="btn-group btn-group-justified ancho-total">
            <router-link tag="a" :key="item.code_product" :to="{ name: 'detalle-productos', params: { id: item.code_product }}" class="btn btn-al-azul-solid btn-sm btn-card">Detalles</router-link>
            <button class="btn btn-al-celeste-solid btn-sm btn-card" v-on:click="addToCart(item)">Agregar</button>
          </div>
          </template>
          -->

              <template v-if="item.allowed_sale">
                <div class="btn-group btn-group-justified ancho-total">
                  <router-link
                    tag="a"
                    :key="item.code_product"
                    :to="{
                      name: 'detalle-productos',
                      params: { id: item.code_product },
                    }"
                    class="btn btn-al-azul-solid btn-sm btn-card"
                    >Elije tus opciones</router-link
                  >
                </div>
              </template>

              <template v-else>
                <small style="display:block;">Producto protegido</small>
                <div class="btn-group btn-group-justified ancho-total">
                  <router-link
                    tag="a"
                    :key="item.code_product"
                    :to="{
                      name: 'detalle-productos',
                      params: { id: item.code_product },
                    }"
                    class="btn btn-al-azul-solid btn-sm btn-card"
                    >Ver Detalles</router-link
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.armaq-top {
  max-width: 100% !important;
  max-height: 100% !important;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.btn-card {
  border-radius: 0 0px 0px 0;
}

.card-text {
  font-size: 13px;
}

.card-text-name {
  font-size: 13px;
  height: 55px !important;
  margin-bottom: 0rem !important;
}

.card-text-price {
  height: 20px !important;
  color: crimson !important;
  font-size: 20px;
}

.card-text-old-price {
  height: 13px !important;
  color: rgb(173, 166, 168) !important;
  font-size: 13px;
  margin-bottom: 0rem !important;
}

.stars-outer {
  display: inline-block;
  position: relative;
  font-family: FontAwesome;
}

.stars-outer::before {
  content: '\f006 \f006 \f006 \f006 \f006';
}

.stars-inner {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
  width: 0%;
}

.stars-inner::before {
  content: '\f005 \f005 \f005 \f005 \f005';
  color: #f8ce0b;
}
</style>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { infoToaster, successToaster } from './service/ErrorHandler';
import { config_settings } from '../../config.js';
import _ from 'lodash';
import axios from 'axios';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error(
          'Usted no tiene los provilegios para acceder a esta sección',
          'ERROR',
          { iconClass: 'customer-danger' },
        );
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'cardTemplateDiscount',
  props: ['item'],
  data() {
    return {
      showModal: false,
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  components: {},
  computed: mapState(['cartProducts']),

  methods: {
    ...mapMutations(['ADD_CART_LOCAL']),

    addToCart(product) {
      this.asignarVisita(product.code_product);

      const data = this.cartProducts.find(
        prod => prod.code_product === product.code_product,
      );

      if (data) {
        infoToaster(
          'Producto ya existente:',
          'El producto ya se encuentra agregado al carrito.',
        );
      } else {
        successToaster(
          'Añadido exitosamente:',
          'El producto fue agregado exitosamente al carrito.',
        );
        //agregando atributo cantidad
        product.qty = 1;
        this.ADD_CART_LOCAL(product);
      }
    },

    obtener_promedio_rating(rank) {
      this.rating = rank;
      const total_estrellas = 5;
      const porcentaje_estrellas = (this.rating / total_estrellas) * 100;
      const redondeado_a_diez = (porcentaje_estrellas / 10) * 10;
      return redondeado_a_diez;
    },

    asignarVisita(code) {
      axios
        .put(
          config_settings.RESOURCE_SERVER_URL +
            '/PUT/catalog/products/' +
            code +
            '/views',
        )
        .then(response => {
          console.log('Se registro vista de producto');
        })
        .catch(error => {
          console.log('Ocurrio un error al regstrar la vista del producto');
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
